export default "__VITE_ASSET__BIIpbjvp__"